import type { GroupInfo, UserFocus } from '@/hooks/use-focus-store'

export type FocusSwitchOption = Pick<GroupInfo, 'name' | 'display_name'>

function toTitle(name: string): string {
  return name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
}

/** Radio items for the account role switcher. */
export function resolveFocusSwitchOptions(
  groups: GroupInfo[],
  focus: UserFocus | null,
  selfServiceLocked: boolean,
): FocusSwitchOption[] {
  if (selfServiceLocked && (focus?.available_foci?.length ?? 0) > 0) {
    return (focus?.available_foci ?? []).map((name) => {
      const group = groups.find((item) => item.name === name)
      return {
        name,
        display_name: group?.display_name || toTitle(name),
      }
    })
  }

  return groups
    .filter((group) => group.is_assigned)
    .map(({ name, display_name }) => ({ name, display_name }))
}
